import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { hideResults, showResults } from '../../Actions/QuickSearch.action';
import Icon from '../IconBase/Icon';
import(`./styles/${global.ThemeName}.scss`);
const QuickSearchController = () => {
  const dispatch = useDispatch();

  const closeIconOnClick = () => {
    dispatch(hideResults());
  };
  const searchIconOnClick = () => {
    dispatch(showResults());
  };

  return (
    <div className="quick-search-controller">
      <div className="quick-search-controller__icon-container">
        <Icon
          className="quick-search__submit-icon"
          iconCode="search"
          onClick={searchIconOnClick}
        />
      </div>
    </div>
  );
};

export default QuickSearchController;
